import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// i18n for legacy components
import { withTranslation } from 'react-i18next';

// Actions
import { gameActions } from '../actions';

class Reopen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    // Bindings
    this.toggleModal = this.toggleModal.bind(this);
    this.openGroup = this.openGroup.bind(this);
  }

  //   componentDidMount() {}

  toggleModal() {
    this.setState({ modal: !this.state.modal });
  }

  openGroup() {
    const { dispatch, game, group, player } = this.props;
    if (group) return dispatch(gameActions.setGroups(game, [group]));
    if (player) return dispatch(gameActions.setPlayers(game, [player]));
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <small
          className='btn btn-link btn-sm'
          style={{ fontSize: '.7rem', cursor: 'pointer' }}
          onClick={this.toggleModal}>
         ({t('Reopen')})
        </small>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal}
          centered={true}>
          <ModalHeader>{t('Reopen Discussion')}</ModalHeader>
          <ModalBody className='text-center'>
            <p>{t('You are about to reopen a closed discussion.')}</p>
          </ModalBody>
          <ModalFooter>
            <button className='btn btn-light' onClick={this.toggleModal}>
              {t('Cancel')}
            </button>
            <button
              className='btn btn-outline-primary'
              onClick={this.openGroup}>
              {t('Open')}
            </button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const {} = state;
  return {};
}

// i18n for legacy components
const ReopenWithTranslation = withTranslation()(Reopen);

export default connect(mapStateToProps)(ReopenWithTranslation);
